// extracted by mini-css-extract-plugin
module.exports = {"text":"legislation_content-module__text--K1MR8","display":"legislation_content-module__display--3qtyc"};